export default __webpack_public_path__ + "static/fast-title-11a264d07630d3d751e6647edbf58734.png";